import { useMemo } from "react";
import { useSelector } from "react-redux";
import { ProjectInfoDc } from "@evergis/api";

import { dialogResourceSelector } from "../../../../ducks/dialogs/selectors";
import { useInputResource } from "../../../../modules/Catalog/hooks/useInputResource";
import { projectInfosWithDeps, projects } from "../../../../resources/projects";

export const useLayerCount = (projectName: string): number => {
  const { data } = projectInfosWithDeps.use({ input: [projectName] });

  return useMemo(() => (data && data.deps.layers.length) || 0, [data]);
};

export const useCurrentResource = (): ProjectInfoDc => {
  const input = useInputResource();
  const { data } = projects.use({ input, waitInput: true });
  const currentResource = useSelector(dialogResourceSelector);
  const projectItems = data?.items;

  return useMemo(
    () => (Array.isArray(projectItems) ? projectItems.find(resource => resource.name === currentResource) : null),
    [projectItems, currentResource],
  );
};
